module.exports = __webpack_public_path__ + "static/media/lr.0b463f64.png";